module.exports = __webpack_public_path__ + "02_long_brown.3b92ba21.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_long_brown.png
// module id = 3MA5
// module chunks = 0